export default __webpack_public_path__ + "static/media/janet.cc56d2ae.png";